import { React, useEffect, useState } from "react";
import { Button, Form, Input, Select, Col, Row, Checkbox, Radio } from "antd";
import warning from "../../../Assets/Icons/warning.png";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  DropDownSearchDraw,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { DatePicker } from "antd";
import { DatePickerY } from "../../pageStyled";
import {
  cancelOrderQuantity,
  getAllOrdersListByOrderno,
  getPendingOrderDetailsById,
  saveSplitOrder,
  sheetMatchingSplitOrder,
} from "../../../Services/orderServices";
import moment from "moment";
import { getProductDetails } from "../../../Services/productServices";
import {
  addNewCustomer,
  getCustomerDetails,
  getCustomersForConfiguration,
} from "../../../Services/customerServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { ModalPopup } from "../../../Components/Modal/modal";
import { Collapse } from "antd";
import { getUnitData } from "../../../Services/measurementService";
import {
  weightUnit,
  weight_Unit_Conversions,
  orderDim_Rewinder_Unit_Conversion,
  conversionFactorUnitsToTonne,
  conversionFactorTonneToUnits,
  CoversionFactorUnitsToCM,
  lengthUnit,
} from "../../../Utils/Constant/MeasurementUnitList";
import { capital_letter, toHandlePOName } from "../../../Utils/helper/helper";

const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);
const { Option } = Select;
const { TextArea } = Input;
const { Panel } = Collapse;

const customerTypeData = [
  { label: "Dealer", value: "dealer" },
  { label: "Direct Customer", value: "direct_customer" },
];

const AddNewCustomerDrawer = (props) => {
  const [form] = Form.useForm();

  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [customersList, setCustomersList] = useState([]);
  const [aliasList, setAliasList] = useState([]);

  useEffect(() => {
    getCustomersForConfiguration().then((response) => {
      const list = response.map((customer) => customer.alias);
      const customers = response.map((customer) => customer.name);
      setCustomersList(customers);
      setAliasList(list);
    });
  }, []);

  const handleClose = () => {
    props.onClose();
  };

  const onFinish = async (e) => {
    let customerName = capital_letter(e?.name?.trim()?.replace(/\s+/g, " "));
    const body = {
      address_line_1: null,
      address_line_2: null,
      state: null,
      city: null,
      pincode: null,
      country: null,
      delivery_address_line_1: null,
      delivery_address_line_2: null,
      delivery_state: null,
      delivery_city: null,
      delivery_pincode: null,
      delivery_country: null,
      primary_phone_number: null,
      secondary_phone_number: null,
      primary_email: null,
      secondary_email: null,
      // name: e.name.charAt(0).toUpperCase() + e.name.slice(1),
      name: customerName,
      alias: e.alias.toUpperCase(),
      type: e.type,
      person_of_contact: null,
      gst_number: null,
      pan_number: null,
      same_as_office_address: true,
      dealership_date: null,

      reel_diameter: 'single',
      status: "active",
      remarks: null,
      category: null,
    };

    try {
      const response = await addNewCustomer(body);
      if (!response.error) {
        props.toasterAction({
          error: response.error,
          data: response.data,
          msg: response.msg,
        });
        props.showToaster();
        props.onCustSave(response);
      }
    } catch (error) {
      props.toasterAction({
        error: error.response.data.error,
        msg: error.response.data.msg,
      });
      props.showToaster();
      props.rendering(true);
      props.onClose();
    }
  };

  return customersList.length ? (
    <RightDrawerSidebar
      title={`Add New ${(props?.role == "consignee")?"Consignee":"Customer"}`}
      subtitle=""
      visible={props.visible}
      onClose={handleClose}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          {visibleToaster && (
            <AlertContainer
              setClose={setVisibleToaster}
              color={actionToaster.error ? "red" : "green"}
              icon={actionToaster.error ? alertRed : alertGreen}
              msg={actionToaster.msg}
              closeIcon={true}
            />
          )}
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "5px" }}
                onFinish={onFinish}
                form={form}
              >
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>{(props?.role == "consignee")?"Consignee":"Customer"} Name</h5>
                    <p>The {(props?.role == "consignee")?"consignee":"customer"} will be identified by this name</p>
                  </div>
                  <Col span={24}>
                    <Row className="centerAlign  justifyCSBetween">
                      <Col span={24} className="blockBreak">
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            name="name"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                validator(_, value) {
                                  if (
                                    value == null ||
                                    !customersList.filter(
                                      (data) =>
                                        data.toUpperCase() ===
                                        value.toUpperCase()
                                    ).length
                                  ) {
                                    return Promise.resolve();
                                  } else {
                                    return Promise.reject(
                                      `This name exists for another ${(props?.role == "consignee")?"consignee":"customer"}`
                                    );
                                  }
                                },
                              },
                            ]}
                            className="dBlock"
                            initialValue={props.customerName ? props.customerName : ''}
                          >
                            <Input 
                            disabled = {props.customerName}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>{(props?.role == "consignee")?"Consignee":"Customer"} Alias</h5>
                    <p>
                      An alternate short name used to identify this {(props?.role == "consignee")?"consignee":"customer"}
                    </p>
                  </div>
                  <Col span={24}>
                    <Row className="centerAlign  justifyCSBetween">
                      <Col span={24} className="blockBreak">
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            name="alias"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                max: 20,
                                message:
                                  "Alias can have a maximum of 20 characters",
                              },
                              {
                                validator(_, value) {
                                  if (
                                    value == null ||
                                    !aliasList.filter(
                                      (data) =>
                                        data.toUpperCase() ===
                                        value.toUpperCase()
                                    ).length
                                  ) {
                                    return Promise.resolve();
                                  } else {
                                    return Promise.reject(
                                      `This alias exists for another ${(props?.role == "consignee")?"consignee":"customer"}`
                                    );
                                  }
                                },
                              },
                            ]}
                            className="dBlock"
                            initialValue={""}
                          >
                            <Input />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>{(props?.role == "consignee")?"Consignee":"Customer"} Type</h5>
                    <p>{(props?.role == "consignee")?"Consignee":"Customer"} can be a dealer or a direct {(props?.role == "consignee")?"consignee":"customer"}</p>
                  </div>
                  <Col span={24}>
                    <Row className="centerAlign  justifyCSBetween">
                      <Col span={24} className="blockBreak">
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            name="type"
                            className="dBlock"
                            initialValue={customerTypeData[1]?.value}
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              }
                            ]}
                          >
                            <Select
                              placeholder={"Select"}
                              suffixIcon={<DownArrowDraw />}
                              defaultValue={customerTypeData[1].value}
                            >
                              {customerTypeData.map((type) => (
                                <Option key={type.value}>{type.label}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
                <div className="buttonFlex fixedBtm">
                  <Form.Item>
                    <Button htmlType="submit" className="themeBtn">
                      <Iconmoon icon="addcircle" size={16} color="#ffffff" />{" "}
                      Add {(props?.role == "consignee")?"Consignee":"Customer"}{" "}
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Form.Item>
                      <Button
                        key="3"
                        className="textTypeBtn"
                        onClick={handleClose}
                      >
                        Cancel
                      </Button>
                    </Form.Item>
                  </Form.Item>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  ) : (
    ""
  );
};
export default AddNewCustomerDrawer;
